var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup1174(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1174",
    "data-name": "Group 1174",
    transform: "translate(-1417 -2424)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(1417 2424)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "workflow",
    transform: "translate(1427.291 2434.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M8.623,20H2.464A2.464,2.464,0,0,0,0,22.464v6.159a2.464,2.464,0,0,0,2.464,2.464H8.623a2.464,2.464,0,0,0,2.464-2.464V22.464A2.464,2.464,0,0,0,8.623,20ZM2.464,28.623V22.464H8.623v6.159Z",
    transform: "translate(0 -7.661)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M34.087,28.623V22.464A2.464,2.464,0,0,0,31.623,20H25.464A2.464,2.464,0,0,0,23,22.464v6.159a2.464,2.464,0,0,0,2.464,2.464h6.159A2.464,2.464,0,0,0,34.087,28.623Zm-8.623-6.159h6.159v6.159H25.464Z",
    transform: "translate(-8.834 -7.661)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M54.623,20H48.464A2.464,2.464,0,0,0,46,22.464v6.159a2.464,2.464,0,0,0,2.464,2.464h6.159a2.464,2.464,0,0,0,2.464-2.464V22.464A2.464,2.464,0,0,0,54.623,20Zm-6.159,8.623V22.464h6.159v6.159Z",
    transform: "translate(-17.668 -7.661)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M21.369,6.445a1.293,1.293,0,0,0-1.922.419A1.232,1.232,0,0,0,20,8.514l2.464,1.232A1.232,1.232,0,0,0,24,9.383l1.848-2.464A1.232,1.232,0,0,0,25.6,5.194a1.287,1.287,0,0,0-1.9.474A8.623,8.623,0,0,0,7,8.643a1.232,1.232,0,1,0,2.464,0,6.159,6.159,0,0,1,11.906-2.2Z",
    transform: "translate(-2.689 0)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M47,42.493a1.232,1.232,0,0,0-1.534-.363L43,43.361a1.232,1.232,0,0,0-.554,1.651,1.293,1.293,0,0,0,1.922.419,6.159,6.159,0,0,1-11.906-2.2,1.232,1.232,0,1,0-2.464,0,8.623,8.623,0,0,0,16.7,2.975,1.287,1.287,0,0,0,1.9.474,1.232,1.232,0,0,0,.246-1.725Z",
    transform: "translate(-11.522 -16.111)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M51.253,11.8a1.232,1.232,0,0,0,1.608.117l4.927-3.7A1.232,1.232,0,1,0,56.31,6.246l-4.071,3.08-1.1-1.115a1.232,1.232,0,0,0-1.737,1.737Z",
    transform: "translate(-18.862 -2.284)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M9.9,44.094,7.435,42.246a1.232,1.232,0,0,0-1.478,0L3.493,44.094a1.232,1.232,0,0,0-.246,1.725c.6.813,1.6.493,2.217-.123v3.7a1.232,1.232,0,1,0,2.464,0V45.7c.616.616,1.62.936,2.217.123A1.232,1.232,0,0,0,9.9,44.094Z",
    transform: "translate(-1.152 -16.111)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 1.232,
    cy: 1.232,
    r: 1.232,
    transform: "translate(4.311 36.976)",
    fill: "#fafafa"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1174);
export default __webpack_public_path__ + "static/media/Group 1174.aa4bcf56e3f9e3f2fce870194f4f840a.svg";
export { ForwardRef as ReactComponent };